var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceNavButtonActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "77.599 108.131 205.342 205.342",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      paintOrder: "stroke",
      stroke: "rgb(26, 25, 25)",
      fill: "none",
      strokeWidth: 20
    },
    cx: 180.27,
    cy: 210.802,
    r: 102.671
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1A1919",
    fillRule: "evenodd",
    transform: "matrix(2.455415, 0, 0, 2.455415, 131.213959, 161.965073)",
    style: {}
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.2 1.064A3.632 3.632 0 1 0 1.064 6.2l8.526 8.525a3.632 3.632 0 1 0 5.137-5.137L6.2 1.064M30.411 25.274a3.632 3.632 0 1 0-5.137 5.137l8.525 8.525a3.632 3.632 0 0 0 5.137-5.137l-8.525-8.525M25.274 14.726a3.632 3.632 0 0 0 5.137 0L38.936 6.2A3.632 3.632 0 1 0 33.8 1.064l-8.525 8.525a3.632 3.632 0 0 0 0 5.137M14.726 25.274a3.632 3.632 0 0 0-5.137 0L1.064 33.8A3.632 3.632 0 1 0 6.2 38.936l8.525-8.525a3.632 3.632 0 0 0 0-5.137",
    style: {
      strokeWidth: "6.10895px"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceNavButtonActive);
export default __webpack_public_path__ + "static/media/device-nav-button-active.fccb5cae0dddfdf71826a1674024b48f.svg";
export { ForwardRef as ReactComponent };